module.exports = __webpack_public_path__ + "static/media/live.5d6164fe.svg";